module.exports = __webpack_public_path__ + "static/media/emina_brand_banner.1f55e3b7.jpg";